import {
    Dialog as MuiDialog,
    DialogContent, DialogActions,
    DialogTitle, Button, Typography, Stack, IconButton, Icon
} from '@mui/material'

export const Dialog = props => {
    const variant = props.variant || 'primary'

    const handleClose = () => {
        if (props.handleClose)
            props.handleClose()
    }

    const onClose = () => {
        if (!props.disabledClickForClose)
            handleClose()
    }

    const handleApply = () => {
        if (props.handleApply)
            props.handleApply()
    }

    return (
        <MuiDialog
            open={props?.config?.open ?? false}
            onClose={onClose}
            maxWidth={props?.config?.maxWidth ?? 'md'}
            fullWidth={props?.config?.fullWidth ?? false}
            fullScreen={props?.config?.fullScreen ?? false}
            variant={variant}
        >
            {props?.config?.title && (
                <DialogTitle variant={variant}>
                    <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'}>
                        <Typography variant={'h4'} sx={{fontWeight: '700'}}>{props.config.title}</Typography>
                        {!props.noCtaClose && (<IconButton size={'samll'}><Icon sx={{fontWeight: 'bold'}} onClick={handleClose}>close</Icon></IconButton>)}
                    </Stack>
                </DialogTitle>
            )}

            {props.children && (
                <DialogContent variant={variant} sx={(props.noPadding && {padding: 0})}>
                    {props.children}
                </DialogContent>
            )}

            {!props.noCta && (
                <DialogActions variant={variant}>
                    {!props.noCtaCancel && (
                        <Button variant={'tertiary'} onClick={handleClose}>
                            {props.cancelLabel ?? 'Cancel'}
                        </Button>
                    )}
                    {!props.noCtaApply && (
                        <Button variant={'primary'} onClick={handleApply}>
                            {props.applyLabel ?? 'Apply'}
                        </Button>
                    )}
                </DialogActions>
            )}
        </MuiDialog>
    )
}

export default Dialog